<div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-4">
            <label for="templateName">Name *</label>
            <input
                id="templateName"
                type="text"
                pInputText
                [(ngModel)]="template.name"
                required
                (blur)="touched.name = true"
            />
            <small
                class="p-error"
                *ngIf="touched.name && nameMissing"
            >Give this template a name.</small>
        </div>
        <div class="p-field p-col-12 p-md-4">
            <label for="templateLocation">Template Context *</label>
            <p-dropdown
                id="templateLocation"
                [options]="templateLocations"
                [(ngModel)]="template.location"
                placeholder="Select a location"
                (onChange)="onTemplateLocationChange($event)"
                (onBlur)="touched.location = true"
                required
                optionLabel="label"
                optionValue="value"
            ></p-dropdown>
            <small
                class="p-error"
                *ngIf="touched.location && locationMissing"
            >Choose where this template is used.</small>
        </div>
        <div
            class="p-field p-col-12 p-md-12"
            *ngIf="showSubject"
        >
            <label for="subjectContents">Subject</label>
            <br>
            <quill-editor
                #subjectEditor
                class="quill-editor"
                id="subjectContents"
                [(ngModel)]="template.subjectContents"
                format="object"
                [modules]="{toolbar: [], variableToolbar: true}"
                (onEditorCreated)="onEditorCreated()"
                placeholder="Write subject for email"
            ></quill-editor>
        </div>
        <div class="p-field p-col-12 p-md-12">
            <label for="templateContents">Contents *</label>
            <br>
            <quill-editor
                #editor
                class="quill-editor fill-height"
                id="templateContents"
                [(ngModel)]="template.contents"
                format="object"
                [modules]="modules"
                (onEditorCreated)="onEditorCreated()"
                (onBlur)="touched.contents = true"
                placeholder="Write contents of the template here"
            ></quill-editor>
            <small
                class="p-error"
                *ngIf="touched.contents && contentsMissing"
            >Write the contents of the template.</small>
        </div>
    </div>
    <div
        class="p-d-flex p-jc-end p-mb-2"
        *ngIf="errorMessage || missingRequiredFields.length"
    >
        <small
            class="p-error"
            *ngIf="errorMessage"
        >{{ errorMessage }}</small>
        <small *ngIf="!errorMessage">Still required: {{ missingRequiredFields.join(', ') }}</small>
    </div>
    <div class="p-d-flex p-jc-end">
        <button
            pButton
            type="button"
            label="Cancel"
            icon="pi pi-times"
            class="p-button-text"
            (click)="cancel()"
        ></button>
        <button
            pButton
            type="button"
            [label]="isEditMode ? 'Edit Template': 'Create Template'"
            icon="pi pi-check"
            class="p-button-primary"
            [disabled]="missingRequiredFields.length > 0 || saving"
            [loading]="saving"
            (click)="save()"
        ></button>
    </div>
</div>
